export const environment = {
  production: false,
  apiUrl:        'https://happymanagement.yourmealprep.com/api',
  backendUrl:    'https://happymanagement.yourmealprep.com',
  managementUrl: 'https://management-dev.yourmealprep.com',
  /** Host for salesperson signup links, rendered and copied as-is. */
  signupUrl:     'signup.happymealprep.com',
  logoUrl:       'https://happymealprep.com/wp-content/uploads/2020/06/cropped-logo-happy-min-1.png'
};
